<template>
  <div class=" lg:bg-white">
    <div class="container mx-auto lg:py-16 py-10 px-3 relative">
      <div class="absolute top-0 left-0 right-0 lg:w-[80%] h-[80%] w-full lg:h-full z-10">
      </div>
      <div class="p-8 flex lg:flex-row flex-col gap-8 ">
        <div class="lg:w-1/2 h-full flex lg:gap-8 gap-3 flex-col text-white z-20">
          <div class="text-base font-primary font-semibold">OUR VALUES</div>
          <div class="lg:text-4xl text-2xl font-primary font-bold">An Experienced Team of Skilled Professionals</div>
          <div class="lg:text-base text-sm">At our custom home plumbing service, we understand that each home is unique,
            andwe
            take a customized approach to meet your specific needs. From construction to renovation projects, our team
            ofskilled and licensed plumbers has the expertise to handle any plumbing job.</div>
        </div>
        <div class="grid md:grid-cols-2 grid-cols-1 grid-rows-2 gap-5 lg:w-1/2 w-full z-20">
          <div class="grid grid-cols-3 bg-white rounded-sm py-6 px-3 gap-5 relative" v-for="item, index in our_values"
            :key="index" style="box-shadow: 0 0 5px rgba(157, 157, 157,0.5);">

            <div class="flex md:justify-center justify-end items-center col-span-1">
              <span class="absolute top-1 right-1 h-3 w-3 rounded-full bg-secondary animate-ping"></span>
              <img :src="item.image" class="lg:w-[50px] w-[70px] lg:h-[50px] h-[70px]" />
            </div>
            <div class=" flex items-start flex-col justify-center col-span-2 ">
              <div class="text-4xl font-bold font-primary ">{{ item.heading }}</div>
              <div class="text-base font-semibold text-primary ">{{ item.desc }} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

const our_values = [
  {
    image: require("../../assets/v-1.1/Icons/gear-icon.svg"),
    heading: "100%",
    desc: "Happy Customers",
  },
  {
    image: require("../../assets/v-1.1/Icons/headphone.svg"),
    heading: "24x7",
    desc: "Customer Support",
  },
  {
    image: require("../../assets/v-1.1/Icons/grid.svg"),
    heading: "180+",
    desc: "Projects Completed",
  },
  {
    image: require("../../assets//v-1.1/Icons/gear-icon.svg"),
    heading: "Dynamic",
    desc: "Effective Pricing",
  },
];

</script>
<style scoped>
.absolute {
  background: linear-gradient(to right,
      #005CFF 0%,
      #005CFF 80%,
      #ffffff 80%,
      #ffffff 100%);
}

@media only screen and (max-width: 1024px),
only screen and (max-device-width: 1024px) {
  .absolute {
    background: #005CFF;
  }
}
</style>
